const LocalStorageKey = 'explore.local.template.keys';

export const saveTemplateKeyToLocal = (templateStr: string) => {
  const key = templateStr.replaceAll('{{', '').replaceAll('}}', '');
  const templateStringArrayString = localStorage.getItem(LocalStorageKey);
  try {
    const templateStringArray = JSON.parse(templateStringArrayString || '[]');
    const templateStringArraySet = new Set(templateStringArray);
    templateStringArraySet.add(key);
    localStorage.setItem(LocalStorageKey, JSON.stringify(Array.from(templateStringArraySet)));
  } catch (error) {
    console.error(error);
  }
};

export const getTemplateKeysFromLocal: () => string[] = () => {
  const templateStringArrayString = localStorage.getItem(LocalStorageKey);
  try {
    const templateStringArray = JSON.parse(templateStringArrayString || '[]');
    return templateStringArray;
  } catch (error) {
    console.error(error);
  }
};
